/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationPublicDataBuilderVkontakteComVkIdOptions, FxIdApplicationPublicDataBuilderVkontakteComVkIdOptionsFromJSONTyped, FxIdApplicationPublicDataBuilderVkontakteComVkIdOptionsToJSON, } from './FxIdApplicationPublicDataBuilderVkontakteComVkIdOptions';
export function FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComVkIdFromJSON(json) {
    return FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComVkIdFromJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComVkIdFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderVkontakteComVkIdOptions(json)) {
        return FxIdApplicationPublicDataBuilderVkontakteComVkIdOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComVkIdToJSON(json) {
    return FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComVkIdToJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComVkIdToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderVkontakteComVkIdOptions(value)) {
        return FxIdApplicationPublicDataBuilderVkontakteComVkIdOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComVkId.js.map